import { ComposableTypography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { DisplayCostAppearance } from './displayCost.settings';
import { useDisplayCostHelper } from './displayCost.helper';

interface DisplayCostProps {
	cost: number | string;
	appearance: DisplayCostAppearance;
}

export const DisplayCost: React.FC<DisplayCostProps> = ({ cost, appearance }) => {
	const { costText, costAppearance, currencyAppearance, frequencyAppearance } = useDisplayCostHelper(
		cost,
		appearance
	);

	return (
		<ComposableTypography
			text={costText}
			baseProps={costAppearance}
			tags={{
				currency: currencyAppearance,
				frequency: frequencyAppearance,
			}}
		/>
	);
};
